import ReportsApi from '../../apis/Reports';
import SolicitudApi from "../../apis/Solicitud";

export default {
    namespaced: true,
    state: {
        sales: [],
        filters: null,
        sale: null,
        detail: null,
        file_sales: null,
        voucher: null,
        voucher_solicitud: null,
        newFilters: {
            company_id: null,
            sede_id: null,
            office_id: null,
            type_document: null,
            modality: null,
            date_from: null,
            date_until: null,
            customer_id: null,
            product_id: null
        },
        paginated:{},
        paginatedSaleTarjeta: {}
    },
    mutations: {
        set_sales (state, data) {
            state.sales = data;
        },
        set_filters (state, data) {
            state.filters = data;
        },
        set_newFilters (state, data) {
            state.newFilters = data;
        },
        set_sale (state, data) {
            state.sale = data;
        },
        set_detail (state, data) {
            state.detail = data;
        },
        set_file_sales (state, value) {
            state.file_sales = value;
        },
        set_voucher (state, data) {
            state.voucher =  data
        },
        set_voucher_solicitud (state, data) {
            state.voucher_solicitud =  data
        },
        set_paginated (state, data) {
            state.paginated =  data
        },
        set_paginatedSaleTarjeta (state, data) {
            state.paginatedSaleTarjeta =  data
        }
    },
    actions: {
        setSales ({commit}, data) {
            commit('set_sales', []);
        },
        setFilters ({commit}, data) {
            commit('set_filters', data);
        },
        setNewFilters ({commit}, data) {
            commit('set_newFilters', data);
        },
        selectSale ({commit}, data) {
            commit('set_sale', data);
        },
        emptyFileSales ({commit}, value) {
            commit('set_file_sales', value);
        },
        async getSales({commit, dispatch}, filters) {
            commit('set_sales', []);
            return await ReportsApi.getSalesPaginated(filters)
                        .then( response => {
                            commit('set_paginated', {
                                ...response.data
                            })
                            commit('set_sales', response.data.data)
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar ventas, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async getSalesTarjeta({commit, dispatch}, filters) {
            commit('set_sales', []);
            return await ReportsApi.getSalesTarjetaPaginated(filters)
                        .then( response => {
                            commit('set_paginatedSaleTarjeta', {
                                ...response.data
                            })
                            commit('set_sales', response.data.data)
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar ventas, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async getSaleDetail({commit, dispatch}, sale) {
            commit('set_detail', []);
            return await ReportsApi.getSalesDetail(sale)
                        .then( response => {
                            commit('set_detail', response.data);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar detalle de venta, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async salesExcel({commit, dispatch}, filters) {
            commit('set_file_sales', null);
            return await ReportsApi.salesExcel(filters)
                        .then( response => {
                            commit('set_file_sales', response.data.file_sales);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al descargar reporte de ventas, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async saleDetailExcel({commit, dispatch}, sale) {
            commit('set_file_sales', null);
            return await ReportsApi.saleDetailExcel(sale)
                        .then( response => {
                            commit('set_file_sales', response.data.file_excel);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al descargar detalle de venta, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async getSaleVoucher({commit, dispatch}, sale_id) {
            commit('set_voucher', null);
            return await ReportsApi.getSalesVoucher(sale_id)
                .then( response => {
                    console.log(response)
                    commit('set_voucher', response.data);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al imprimir voucher, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async getSolicitudVoucher({commit, dispatch}, solicitud_id){
            commit('set_voucher_solicitud', null);
            return await SolicitudApi.getSolicitudVoucher(solicitud_id)
                .then( response => {
                    console.log(response)
                    commit('set_voucher_solicitud', response.data);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al imprimir voucher, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async getCotizacionVoucher({commit, dispatch}, cotizacion_id) {
            commit('set_voucher', null);
            return await ReportsApi.getCotizacionVoucher(cotizacion_id)
                .then( response => {
                    commit('set_voucher', response.data);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al imprimir cotización, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async saleAccountingExcel({commit, dispatch}, filters) {
            commit('set_file_sales', null);
            return await ReportsApi.saleAccountingExcel(filters)
                .then( response => {
                    commit('set_file_sales', response.data.file_name);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al descargar reporte de ventas, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
    }
}